module.exports = __webpack_public_path__ + "static/media/dcc_loader.b3060877.svg";